import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {Partner} from "../../models/partner.model";
import {VImage} from "../../models/vet-clinic.model";
import {Subscription} from "rxjs";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, Validators} from "@angular/forms";
import {PartnerService} from "../../providers/partner.service";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {FileService} from "../../providers/file.service";

@Component({
  selector: 'app-edit-partner-shop',
  templateUrl: './edit-partner-shop.component.html',
  styleUrls: ['./edit-partner-shop.component.scss'],
})
export class EditPartnerShopComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input() partner: Partner;
  @Input() csrfToken: string;

  @Output() objectEditedEmitter = new EventEmitter<Partner>();
  @Output() objectAddedEmitter = new EventEmitter<Partner>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();


  pc: Partner;
  shopModuleEnabled: boolean = false;
  promotionalCodeProgram: boolean = false;

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private partnerService: PartnerService,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private fileService: FileService
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    this.pc = JSON.parse(JSON.stringify(this.partner));
    this.createEditForm();

    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    super.ngOnInit();
  }

  createEditForm() {
    this.componentTitle = 'Zmień sklep';
    this.actionBtnLabel = 'Zmień sklep';
    this.actionQuestion = 'Na pewno chcesz zmienić sklep partnera?';
    this.actionSuccess = 'Sklep partnera został zmieniony';
    this.actionError = 'Wystąpił błąd podczas zmiany sklepu partnera';
    this.formGroup = this.formBuilder.group({
      shopRedirectionTerms: [this.partner.shopRedirectionTerms, Validators.required],
      shopRedirectionTermsDescription: [this.partner.shopRedirectionTermsDescription, Validators.required],
      appPartnerPageTitle: [this.partner.appPartnerPageTitle, Validators.required],
      appPartnerPageContent: [this.partner.appPartnerPageContent, Validators.required],
      termsOfServicePageContent: [this.partner.termsOfServicePageContent, Validators.required],
    });

    this.shopModuleEnabled = this.partner.shopModuleEnabled;
    this.promotionalCodeProgram = this.partner.promotionalCodeProgram;

  }

  onAction() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      let partnerObj: Partner = this.commonUtils.formGroupValuesToObject<Partner>(new Partner(), this.formGroup);
      console.log(partnerObj);

      this.partner.shopModuleEnabled = this.shopModuleEnabled;
      this.partner.promotionalCodeProgram = this.promotionalCodeProgram;
      this.partner.shopRedirectionTerms = partnerObj.shopRedirectionTerms;
      this.partner.shopRedirectionTermsDescription = partnerObj.shopRedirectionTermsDescription;
      this.partner.appPartnerPageTitle = partnerObj.appPartnerPageTitle;
      this.partner.appPartnerPageContent = partnerObj.appPartnerPageContent;
      this.partner.termsOfServicePageContent = partnerObj.termsOfServicePageContent;

      this.partnerService.updatePartner(this.partner).subscribe(e => {
        if (e) {
          this.objectEditedEmitter.emit(e);
        }
      });

    }, () => {
    });
  }


  ngOnDestroy() {
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
    }
    super.markUnsavedChanges();
  }
}

